import Decimal from 'decimal.js';

/**
 * The decimal context of every quote figure. A clone, so the global `Decimal` other code relies on
 * keeps its own settings.
 *
 * Products and sums stay exact at this precision: amounts below 10^15 at 24 decimal places need
 * about 70 digits. Divisions truncate (`ROUND_DOWN`) at 160 significant digits and are then
 * rounded with `toDecimalPlaces(k, ROUND_HALF_UP)`. Never `ROUND_FLOOR`, which yields `-0`.
 */
export const QuoteDecimal = Decimal.clone({precision: 160, rounding: Decimal.ROUND_DOWN});
export type QuoteDecimal = InstanceType<typeof QuoteDecimal>;
